import React, { Component } from 'react';
import StepFooter from '../StepFooter';
import PropTypes from 'prop-types';
// import PackageViewer from '../PackageViewer';
import _ from 'lodash';

class Step4 extends Component {
  constructor (props) {
    super(props);
    this.state = {
      customer: {
        name: '',
        email: '',
        news: false
      },
      errors: {
        name: false,
        email: false
      },
      dirty: {
        name: false,
        email: false
      }
    };
    this.handleChange = this.handleChange.bind(this);
    this.footerNext = this.footerNext.bind(this);
  }

  getMessage (errors) {
    if (_.filter(_.values(errors), (e) => e).length) {
      return 'Please provide your name and email before clicking next';
    } else {
      return '';
    }
  }

  isEmail (email) {
    let atPosProblem = (email.indexOf('@') < 1) || (email.indexOf('@') === email.length - 1);
    return email.length && !atPosProblem;
  }

  getErrors (state) {
    return {
      name: (state.dirty.name && state.customer.name === ''),
      email: (state.dirty.email && !this.isEmail(state.customer.email))
    };
  }

  footerNext (event) {
    let state = this.state;
    state.dirty = {email: true, name: true};
    state.errors = this.getErrors(state);
    if (this.getMessage(state.errors)) {
      event.preventDefault();
    } else {
      this.props.handleNextClick({
        customer: this.state.customer
      });
    }
    this.setState(state);
  }

  handleChange (event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    let state = this.state;
    state.dirty[name] = true;
    state.customer[name] = value;
    state.errors = this.getErrors(state);
    this.setState(state);
    console.log('state', state);
  }

  render () {
    return (
      <div className='registration__step'>
        <div className='registration__inner'>
          <p className='registration__step-indicator'>Step 4 of 4</p>
          <p className='kilo'>One final thing...</p>
          <p className='error-message' style={{display: 'block', fontSize: '24px'}}>{this.props.serverError}</p>
          <ul className='form-fields'>
            <li>
              <label htmlFor='fullname' className='u-sr-only'>Name</label>
              <input name='name' className={this.state.errors.name && 'has-error'} type='text' required placeholder='Fullname' id='fullName'
                value={this.state.customer.name} onChange={this.handleChange} />
            </li>
            <li>
              <label htmlFor='emailAddress' className='u-sr-only'>Email</label>
              <input name='email' className={this.state.errors.email && 'has-error'} type='email' required placeholder='Email' id='emailAddress'
                value={this.state.customer.email} onChange={this.handleChange} />

              <p className='label-extra'>We need this info so we can create your learning plan and save your progress</p>
            </li>
            <li>
              <p className='label-extra'>By clicking on the 'Next' button below you agree to our <a href='https://s3-eu-west-1.amazonaws.com/static.bslcourses.co.uk/pdfs/bsl-terms.pdf' target='_blank' rel='noopener noreferrer'>Terms</a> and <a href='https://s3-eu-west-1.amazonaws.com/static.bslcourses.co.uk/pdfs/bsl-privacy.pdf' target='_blank' rel='noopener noreferrer'>Privacy Policy</a></p>
              <p className='label-extra'>
                <input
                  type='checkbox'
                  id='news'
                  name='news'
                  onChange={this.handleChange}
                  checked={this.state.news} />
                  Tick this box if you would like to receive emails of discounted courses and any BSL news</p>
            </li>
          </ul>
          <StepFooter
            handlePreviousClick={this.props.handlePreviousClick}
            errorMessage={this.getMessage(this.state.errors)}
            handleNextClick={this.footerNext}
            isLoading={this.props.isLoading} />
        </div>
      </div>
    );
  }
}

Step4.propTypes = {
  handlePreviousClick: PropTypes.func.isRequired,
  handleNextClick: PropTypes.func.isRequired,
  serverError: PropTypes.string,
  isLoading: PropTypes.bool,
  stepState: PropTypes.object
};

export default Step4;



// WEBPACK FOOTER //
// ./src/components/CoursePicker/Step4/index.js